module.exports = __webpack_public_path__ + "img/wxCode.c063910d.jpg";